(function () {
    'use strict';

    class swifCartoLeafletService{
        constructor($compile, settingsService, swifResourcesService, leafletService, dataService, $rootScope, userService) {
            this._ = leafletService;
            this.on = leafletService.on;
            this.resource = swifResourcesService;
            this.settings = settingsService;
            this.$compile = $compile;
            this.data = dataService;
            this.user = userService;
            this.geoPointBySiteId = {};
            this.rootScope = $rootScope
        }
        getLeaflet() {
            return this.settings.app.leaflet;
        }
        addResource() {
            return this.resource.add('leaflet');
        }
        setDefaultCenterView(map) {
            //set the view on the default geolocation with the default view
            let defaultCenter = this.getLeaflet().center;
            map.setView([defaultCenter.lat, defaultCenter.lng], defaultCenter.zoom);
        }
        getMarkerFromPoint(point, options) {
            var latlng = this.getLatLngFromPoint(point);
            if (latlng) {
                return L.marker(latlng, options);
            }
        }
        getMarkerFromLine(line, options) {
            return L.polyline(line.coordinates, options)
        }
        getMarkerFromMultiLine(multiLine, options) {
            return L.multiPolyline(multiLine.coordinates, options)
        }
        getMarkerFromPolygon(polygon, options) {
            return L.polygon(polygon.coordinates, options)
        }
        getMarkerFromMultiPolygon(multiPolygon, options) {
            return L.multiPolygon(multiPolygon.coordinates, options)
        }
        getPointFromLatLng(lat, lon) {
            return `{"type": "Point", "coordinates": [${lon}, ${lat}]}`;
        }
        getLatLngFromPoint(point) {
            var data = point;
            if (typeof point === 'string') {
                data = JSON.parse(point);
            }
            var c = data.coordinates;
            if (c) {
                return [c[1], c[0]];
            }
        }
        getPanelHTML(proxy, scope, options) {
            if (proxy._type === "patrimoine_site") {
                proxy._type = "site";
            }
            if (proxy._type==="patrimoine_equipment"){
                proxy._type="equipment";
            }
            var header, footer;
            if (options) {
                if (options.header) {
                    header = options.header;
                }
                if (options.footer) {
                    footer = options.footer;
                }
            }
            let message = `<div>
                ${header ? header : ''}
                <swif-panel ng-model="proxy"></swif-panel>
                ${footer ? footer : ''}
            </div>`;
            let nscope = scope.$new();
            nscope.proxy = proxy;
            return this.$compile(message)(nscope)[0];
        }
        getVSNPanelHTML(proxy, scope) {
            if (proxy._type === 'patrimoine_site') {
                proxy._type = 'site';
            }
            if (proxy._type==='patrimoine_equipment'){
                proxy._type='equipment';
            }
            let message = `<div class='panel panel-default panel-site' >
                <div class='panel-heading'>
                    <span class='transclude'>${proxy.id} - ${proxy.name}</span>
                </div>
                <div class='panel-body panel-popup'>
					<div>
                        <strong>Nom</strong>&nbsp;:
                        ${proxy.name}
                    </div>
					<div ng-if='${proxy.street !== undefined && proxy.street !== false}'>
                        <strong>Rue</strong>&nbsp;:
                        ${proxy.street}
                    </div>
					<div ng-if='${proxy.zip !== undefined && proxy.zip !== false}'>
                        <strong>Code postal</strong>&nbsp;:
                        ${proxy.zip}
                    </div>
					<div ng-if='${proxy.city !== undefined && proxy.city !== false}'>
                        <strong>Ville</strong>&nbsp;:
                        ${proxy.city}
                    </div>
					<div ng-if='${proxy.type_id !== undefined && proxy.type_id !== false}'>
                        <strong>Catégorie</strong>&nbsp;:
                        ${proxy.type_id[1]}
                    </div>
					<div ng-if='${proxy.service_names !== undefined && proxy.service_names !== false && proxy.service_names.length > 0}'>
                        <strong>Services mainteneurs</strong>&nbsp;:
                        <ul>
                            ${proxy.service_names.map((service) => {
                                return `<li>${service[1]}</li>`
                            }).join('')}
                        </ul>
                    </div>
                </div>
                <div class='panel-footer pannel-popup'>
                    <div>
                        <a class='col-md-6 btn btn-xs btn-link' id='detail-${proxy.id}'
                                tooltip='Afficher le détail du site'
                                data-toggle="tooltip" data-placement="bottom" title="Afficher le détail du site">
                            <i class='fa fa-eye fa-lg' />
                        </a>
                        <a class='col-md-6 btn btn-xs btn-link' id='select-${proxy.id}'
                                tooltip='Sélectionner le site'
                                data-toggle="tooltip" data-placement="bottom" title="Sélectionner le site">
                            <i class='fa fa-check fa-lg' />
                        </a>
                    </div>
                </div>
            </div>`;
            let nscope = scope.$new();
            nscope.proxy = proxy;
            return this.$compile(message)(nscope)[0];
        }
        getColorFromState(item) {
            /** supported values from leaflet.awesome-markers are :
             red
             darkred
             lightred
             orange
             beige
             green
             darkgreen
             lightgreen
             blue
             darkblue
             lightblue
             purple
             darkpurple
             pink
             cadetblue
             white
             gray
             lightgray
             black
             */
            if (
                (item._type === 'intervention' && item.state === 'open') ||
                (item._type === 'task' && item.state === 'draft') ||
                (item._type === 'intervention_request' && item.state === 'draft') ||
                (item._type === 'intervention_request' && item.state === 'to_confirm') ||
                (item._type === 'intervention_request' && item.state === 'confirmed')
            ) {
                return 'orange';
            }
            if (
                (item._type === 'task' && item.state === 'open') ||
                (item._type === 'intervention_request' && item.state === 'wait') ||
                (item._type === 'intervention' && item.state === 'scheduled')
            ) {
                return 'blue';
            }
            if (
                (item._type === 'task' && item.state === 'pending') ||
                (item._type === 'intervention_request' && item.state === 'finished') ||
                (item._type === 'intervention' && item.state === 'pending')
            ) {
                return 'lightgray';
            }
            if (
                (item._type === 'intervention' && item.state === 'cancelled') ||
                (item._type === 'task' && item.state === 'cancelled') ||
                (item._type === 'intervention_request' && item.state === 'refused')
            ) {
                return 'red';
            }
            if (
                (item._type === 'task' && item.state === 'done') ||
                (item._type === 'intervention_request' && item.state === 'valid') ||
                (item._type === 'intervention' && item.state === 'finished')
            ) {
                return 'green';
            }
            return 'blue';
        }
        getSitesWithGeoPoint(records, filter) {
            var $ctrl = this;
            var siteIds = [];
            records.map(function (item) {
                if (item.site1) {
                    let siteId = item.site1[0];
                    if (!_.contains(siteIds, siteId)) {
                        siteIds.push(siteId);
                    }
                }
            });
            if (!filter) {
                filter = {};
            }
            if (!filter.fields) {
                filter.fields = ['geo_point','id'];
            }

            this.data.addFilter(filter, 'geo_point', '!=', false);
            this.data.addFilter(filter, 'id', 'in', siteIds);
            return this.data.searchRead('site', filter).then(function (sites) {
                return sites.records;
            });
        }
        setChildAndParentsPolygons(sites) {
            /**
            * @description set polygon(s) and highlight the selected site:
            * The last items MUST be the selected site
            * @return An array of leaflet-formatted polygon(s) marker(s)
            **/
            return sites.filter(site => site.geo_polygon).map((site, idx, arr) => {
                var geoPolygon = JSON.parse(site.geo_polygon);
                return this.getMarkerFromPolygon(
                    geoPolygon,
                    {
                        // Highlight the last site (aka the selected site) from sites
                        color: (idx == arr.length -1) ? 'orange' : 'blue'
                    }
                );
            });
        }
        getParentSiteWithPolygon(site_id) {
            return this.data.callKw(
                'site',
                'get_parents_with_polygon',
                [
                    [site_id]
                ],
                {
                    context: this.user.getAuthenticatedUser().context
                }
            );
        }
        getGeoPointBySiteId(records) {
            var $ctrl = this;
            return this.getSitesWithGeoPoint(records).then(function (sites) {
                sites.forEach(function (site) {
                    $ctrl.geoPointBySiteId[site.id] = site.geo_point;
                });
                return $ctrl.geoPointBySiteId;
            });
        }
        removeLayerFromMap(layer, map, removeAllLayer) {
            if (layer) {
                if(removeAllLayer) {
                    if (map.hasLayer(layer)) {
                        map.eachLayer(function (l) {
                            if(l && !l._url)
                                map.removeLayer(l);
                         });
                    }
                } else {
                    if (map.hasLayer(layer)) {
                        map.removeLayer(layer);
                    }
                }
            }
        }
        getIconFromSite(site){
            return L.AwesomeMarkers.icon({
                icon: 'info',
                markerColor: this.getColorFromState(site),
                iconColor: 'white',
                prefix: 'fa'
            });
        }
    }
    swifCartoLeafletService.$inject = ['$compile', 'settingsService', 'swifResourcesService', 'leafletService', 'dataService', '$rootScope', 'userService'];

    angular.module('swif.carto')
        .service('swifCartoLeafletService', swifCartoLeafletService);

})();
